import { render, staticRenderFns } from "./RiskLevelScheme.vue?vue&type=template&id=6e71a8ad&scoped=true&"
import script from "./RiskLevelScheme.vue?vue&type=script&lang=ts&"
export * from "./RiskLevelScheme.vue?vue&type=script&lang=ts&"
import style0 from "./RiskLevelScheme.vue?vue&type=style&index=0&id=6e71a8ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e71a8ad",
  null
  
)

export default component.exports